/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EngineLoadLimits } from './EngineLoadLimits';
import type { EngineSpeedLimits } from './EngineSpeedLimits';
import type { PedalLimits } from './PedalLimits';
import type { PrivateSwitch } from './PrivateSwitch';
import type { SensorSetup } from './SensorSetup';
import type { VehicleCommandType } from './VehicleCommandType';
import type { VehicleSetupIn } from './VehicleSetupIn';
/**
 * Vehicle setup for save
 */
export type VehicleSetupSet = {
    /**
     * Harsh acceleration tolerance (G)
     */
    acceleration_tolerance?: number | null;
    /**
     * Harsh braking tolerance (G)
     */
    braking_tolerance?: number | null;
    /**
     * Nominal of CAN fuel tank, if not set, can_fuel not available (L)
     */
    can_fuel_volume?: number | null;
    commands?: Array<VehicleCommandType>;
    /**
     * Communication timeout (sec)
     */
    communication_timeout?: number | null;
    /**
     * Consumption norm
     */
    consumption_norm?: number | null;
    /**
     * Harsh cornering tolerance (G)
     */
    cornering_tolerance?: number | null;
    /**
     * Cruise control enabled
     */
    cruise_control?: boolean | null;
    /**
     * DDD download available
     */
    ddd?: boolean | null;
    engine_load_limits?: EngineLoadLimits;
    engine_speed_limits?: EngineSpeedLimits;
    ext_in_1?: VehicleSetupIn;
    ext_in_2?: VehicleSetupIn;
    ext_in_3?: VehicleSetupIn;
    ext_in_4?: VehicleSetupIn;
    ext_in_5?: VehicleSetupIn;
    /**
     * Has CAN flow meter
     */
    flow_meter?: boolean | null;
    fms_pto?: {
        /**
         * Name of the PTO
         */
        name: string | null;
    };
    /**
     * Fuel loss tolerance (L)
     */
    fuel_loss_tolerance?: number | null;
    /**
     * Number of fuel probes available
     */
    fuel_probes?: number;
    /**
     * GPS available (if not set, GPS is available by default)
     */
    gps?: boolean | null;
    humidity?: Array<SensorSetup> | null;
    /**
     * Idle tolerance (sec)
     */
    idle_tolerance?: number | null;
    in_1?: VehicleSetupIn;
    in_2?: VehicleSetupIn;
    in_3?: VehicleSetupIn;
    in_4?: VehicleSetupIn;
    in_5?: VehicleSetupIn;
    /**
     * Path area width (meters)
     */
    path_area_width?: number | null;
    pedal_limits?: PedalLimits;
    private_switch?: (PrivateSwitch | 'none');
    /**
     * Vehicle has real odometer available, ie.: DTCO/CAN
     */
    real_odometer?: boolean | null;
    /**
     * Refueling tolerance (L)
     */
    refueling_tolerance?: number | null;
    /**
     * Speed limit (km/h)
     */
    speed_limit?: number | null;
    /**
     * Temperature sensors
     */
    temperature?: Array<SensorSetup> | null;
    /**
     * Minimal trip duration (sec)
     */
    trip_duration?: number | null;
    /**
     * Uses odometer
     */
    uses_odometer?: boolean | null;
    /**
     * Voltage system, if not set = auto
     */
    voltage_system?: VehicleSetupSet.voltage_system | null;
};
export namespace VehicleSetupSet {
    /**
     * Voltage system, if not set = auto
     */
    export enum voltage_system {
        _12V = '12V',
        _24V = '24V',
        AUTO = 'auto',
    }
}

